var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeople2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.975,
    height: 54.975,
    viewBox: "0 0 54.975 54.975",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_outline_people",
    "data-name": "vuesax/outline/people",
    transform: "translate(-620 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "people",
    transform: "translate(620 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.857,15.233h-.3a7.057,7.057,0,1,1,.321.023C7.88,15.233,7.88,15.233,7.857,15.233ZM7.628,3.413a4.193,4.193,0,0,0-.16,8.384,1.11,1.11,0,0,1,.412,0,4.2,4.2,0,0,0-.252-8.384Z",
    transform: "translate(33.374 2.886)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M4.171,14.95a15.125,15.125,0,0,1-2.68-.229,1.721,1.721,0,1,1,.6-3.39A11.166,11.166,0,0,0,9.875,9.957a3.142,3.142,0,0,0,1.649-2.5A3.164,3.164,0,0,0,9.875,4.986,11.207,11.207,0,0,0,2.018,3.635a1.7,1.7,0,0,1-1.993-1.4A1.718,1.718,0,0,1,1.423.244,14.5,14.5,0,0,1,11.776,2.123,6.524,6.524,0,0,1,14.96,7.46a6.568,6.568,0,0,1-3.184,5.36A13.94,13.94,0,0,1,4.171,14.95Z",
    transform: "translate(37.083 20.05)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M7.422,15.255H7.376a7.616,7.616,0,1,1,.527,0l-.481-1.718.16,1.718Zm.229-3.436a2.222,2.222,0,0,1,.389.023,4.261,4.261,0,1,0-.6,0A.452.452,0,0,1,7.651,11.82Z",
    transform: "translate(6.253 2.863)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M10.789,14.95a13.94,13.94,0,0,1-7.6-2.13A6.561,6.561,0,0,1,0,7.46,6.555,6.555,0,0,1,3.184,2.123,14.5,14.5,0,0,1,13.537.244a1.718,1.718,0,0,1,1.4,1.993,1.7,1.7,0,0,1-1.993,1.4A11.23,11.23,0,0,0,5.085,4.986,3.109,3.109,0,0,0,3.436,7.46a3.2,3.2,0,0,0,1.649,2.5,11.166,11.166,0,0,0,7.788,1.374,1.721,1.721,0,1,1,.6,3.39A15.125,15.125,0,0,1,10.789,14.95Z",
    transform: "translate(2.863 20.05)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M7.857,15.233h-.3a7.057,7.057,0,1,1,.321.023C7.88,15.233,7.88,15.233,7.857,15.233ZM7.628,3.413a4.193,4.193,0,0,0-.16,8.384,1.11,1.11,0,0,1,.412,0,4.2,4.2,0,0,0-.252-8.384Z",
    transform: "translate(19.63 19.997)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M10.812,14.981a13.737,13.737,0,0,1-7.628-2.153A6.524,6.524,0,0,1,0,7.49,6.537,6.537,0,0,1,3.184,2.13a14.721,14.721,0,0,1,15.255,0,6.524,6.524,0,0,1,3.184,5.337,6.537,6.537,0,0,1-3.184,5.36A13.926,13.926,0,0,1,10.812,14.981ZM5.085,5.016a3.142,3.142,0,0,0-1.649,2.5A3.164,3.164,0,0,0,5.085,9.987a11.228,11.228,0,0,0,11.43,0,3.142,3.142,0,0,0,1.649-2.5,3.164,3.164,0,0,0-1.649-2.474A11.281,11.281,0,0,0,5.085,5.016Z",
    transform: "translate(16.675 37.154)",
    fill: "#ea8713",
    stroke: "#fff",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector-7",
    "data-name": "Vector",
    fill: "none",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0H54.975V54.975H0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 0.4999961853027344 0.4999961853027344 L 0.4999961853027344 54.47460556030273 L 54.47460556030273 54.47460556030273 L 54.47460556030273 0.4999961853027344 L 0.4999961853027344 0.4999961853027344 M -3.814697265625e-06 -3.814697265625e-06 L 54.97460556030273 -3.814697265625e-06 L 54.97460556030273 54.97460556030273 L -3.814697265625e-06 54.97460556030273 L -3.814697265625e-06 -3.814697265625e-06 Z",
    stroke: "none",
    fill: "#707070"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople2);
export default __webpack_public_path__ + "static/media/people2.32cd14e44f4f65c12d4aebd105bd799d.svg";
export { ForwardRef as ReactComponent };